import clsx from "clsx";

import { forwardRef } from "react";

import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

const Input = forwardRef(function Input(props, ref) {
  const {
    type,
    name,
    placeholder,
    label,
    value,
    onChange,
    onBlur,
    errorMessage,
    postFix,
    defaultValue,
    autoComplete,
    isValid = true,
  } = props;

  const handleChange = (e) => {
    e.preventDefault();

    if (!!onChange && typeof onChange === "function") {
      onChange(e.target.value);
    }
  };

  const handleBlur = (e) => {
    e.preventDefault();

    if (!!onBlur && typeof onBlur === "function") {
      onBlur(e.target.value);
    }
  };

  return (
    <div>
      {label && (
        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
      )}
      <div className="relative mt-1 rounded-md shadow-sm">
        {!isValid && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
        <input
          ref={ref}
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          autoComplete={autoComplete}
          onChange={handleChange}
          onBlur={handleBlur}
          className={clsx(
            "block w-full rounded-md border-0 py-1.5 ring-1 ring-inset focus:ring-2 focus:ring-inset shadow-sm sm:text-sm sm:leading-6",
            !!postFix ? "pr-12" : "",
            !isValid
              ? "pl-10 border-red-300 text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500"
              : "border-gray-300 text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-indigo-600 focus:border-indigo-500"
          )}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <span className="text-gray-500 sm:text-sm" id="post-fix">
            {postFix}
          </span>
        </div>
      </div>
      {!isValid && (
        <p className="mt-2 flex justify-left sm:text-sm text-red-600" id="result-error">
          {errorMessage}
        </p>
      )}
    </div>
  );
});

export default Input;
